import { TRACK_EVENTS, TRACK_EVENT_TYPES } from 'shared/consts/track-events';
import React, { useCallback } from 'react';

import { AvailableServiceView } from 'store/availableServices/types';
import { ButtonProps } from '@hqo/react-components-library';
import { StyledBookingTile } from './styles';
import { track } from '@hqo/web-tracking';

export interface ScheduleListProps {
  service: AvailableServiceView;
  status: string | undefined;
  actionButton: ButtonProps;
  disabled: boolean;
  onActionButtonClick?: (service: AvailableServiceView) => void;
  onClick?: (service: AvailableServiceView) => void;
  formattedPrice?: string;
  formattedDate?: string;
  formattedTimeSlot?: string;
  title: string;
  subtitle: string;
  displayConfirmedIcon?: boolean;
}

export const BookingTile = ({
  service,
  status,
  disabled,
  onClick,
  onActionButtonClick,
  actionButton,
  formattedPrice,
  formattedDate,
  formattedTimeSlot,
  title,
  subtitle,
  displayConfirmedIcon,
}: ScheduleListProps) => {
  const handleOnActionButtonClick = useCallback(() => {
    track(TRACK_EVENTS.BOOK_CLICK, { type: TRACK_EVENT_TYPES.ACTION }, { sendToPendo: true, sendToHqoTracking: false });
    if (onActionButtonClick) onActionButtonClick(service);
  }, [onActionButtonClick, service]);

  const handleOnClick = useCallback(() => {
    if (onClick) onClick(service);
  }, [onClick, service]);

  return (
    <StyledBookingTile
      actionButton={actionButton}
      dataTestId={`${service?.uuid}-class-test-id`}
      displayConfirmedIcon={displayConfirmedIcon}
      formattedDate={formattedDate}
      formattedPrice={formattedPrice}
      formattedTimeSlot={formattedTimeSlot}
      status={status}
      disabled={disabled}
      onActionButtonClick={handleOnActionButtonClick}
      onClick={handleOnClick}
      title={title}
      subtitle={subtitle}
    />
  );
};
